const MCC_CATEGORY_RULES = [
  { key: 'pets', codes: [742, 5995] },
  { key: 'agricultureGarden', codes: [763, 780, 5261] },
  {
    key: 'homeImprovement',
    codes: [
      1520, 1711, 1731, 1740, 1750, 1761, 1771, 1799,
      5039, 5072, 5074, 5198, 5200, 5211, 5231, 5251, 5718, 5996, 5998,
    ],
  },
  { key: 'printing', codes: [2741, 2791, 7338] },
  { key: 'airlines', codes: [4511], ranges: [[3000, 3308]] },
  { key: 'carRental', codes: [7512, 7513, 7519], ranges: [[3351, 3441]] },
  { key: 'lodging', codes: [7011, 7012, 7032, 7033], ranges: [[3501, 3883]] },
  { key: 'rail', codes: [4011, 4112] },
  { key: 'publicTransport', codes: [4111, 4131] },
  { key: 'ambulance', codes: [4119] },
  { key: 'taxi', codes: [4121] },
  { key: 'deliveryStorage', codes: [4214, 4215, 4225] },
  { key: 'cruises', codes: [4411] },
  { key: 'marine', codes: [4457, 4468, 5551] },
  { key: 'travelServices', codes: [4582, 4722, 4723, 5962] },
  { key: 'tollsParking', codes: [4784, 7523] },
  { key: 'otherTransport', codes: [4789] },
  { key: 'telecom', codes: [4812, 4814, 4821] },
  { key: 'internetServices', codes: [4816] },
  { key: 'moneyTransfer', codes: [4829] },
  { key: 'televisionStreaming', codes: [4899] },
  { key: 'utilities', codes: [4900] },
  {
    key: 'businessSupplies',
    codes: [2842, 5046, 5051, 5065, 5085, 5099, 5169, 5199],
  },
  { key: 'officeSupplies', codes: [5021, 5111, 5978] },
  { key: 'marketplaces', codes: [5262] },
  { key: 'generalRetail', codes: [5300, 5309, 5310, 5311, 5331, 5399] },
  { key: 'groceries', codes: [5411, 5422, 5441, 5451, 5462, 5499] },
  { key: 'vehicles', codes: [5271, 5511, 5521, 5561, 5571, 5592, 5598, 5599] },
  { key: 'autoParts', codes: [5013, 5532, 5533] },
  { key: 'fuel', codes: [5172, 5541, 5542, 5983] },
  { key: 'evCharging', codes: [5552] },
  {
    key: 'clothing',
    codes: [
      5131, 5137, 5139, 5611, 5621, 5631, 5641, 5651, 5655,
      5661, 5681, 5691, 5697, 5698, 5699, 7296,
    ],
  },
  { key: 'homeFurniture', codes: [5712, 5713, 5714, 5719, 5722] },
  { key: 'weapons', codes: [5723] },
  { key: 'electronics', codes: [5045, 5732] },
  { key: 'music', codes: [5733, 5735] },
  { key: 'restaurants', codes: [5811, 5812] },
  { key: 'bars', codes: [5813] },
  { key: 'fastFood', codes: [5814] },
  { key: 'digitalMedia', codes: [5815] },
  { key: 'videoGames', codes: [5816, 7993, 7994] },
  { key: 'appsSoftware', codes: [5734, 5817, 5818] },
  { key: 'pharmacies', codes: [5122, 5912] },
  { key: 'alcohol', codes: [5921] },
  { key: 'secondHand', codes: [5931, 5932, 5933, 5935, 5937] },
  { key: 'sportsOutdoors', codes: [5940, 5941] },
  { key: 'booksStationery', codes: [5192, 5942, 5943, 5994] },
  { key: 'jewelry', codes: [5094, 5944] },
  { key: 'hobbiesToys', codes: [5945, 5972] },
  { key: 'photo', codes: [5044, 5946, 7221, 7333, 7395] },
  { key: 'giftsFlowers', codes: [5193, 5947, 5992] },
  { key: 'luggageLeather', codes: [5948] },
  { key: 'craftsArt', codes: [5949, 5970, 5971] },
  { key: 'medicalSupplies', codes: [5047, 5975, 5976] },
  { key: 'beauty', codes: [5977, 5997, 7230, 7297, 7298] },
  { key: 'insurance', codes: [5960, 6300] },
  { key: 'directMarketing', codes: [5963, 5964, 5965, 5966, 5969] },
  { key: 'adult', codes: [5967] },
  { key: 'subscriptions', codes: [5968] },
  { key: 'religious', codes: [5973, 8661] },
  { key: 'tobacco', codes: [5993] },
  { key: 'specialtyRetail', codes: [5950, 5999] },
  { key: 'cashWithdrawal', codes: [6010, 6011] },
  { key: 'financialServices', codes: [6012, 6051, 6211, 6540] },
  { key: 'realEstate', codes: [6513] },
  { key: 'laundryCleaning', codes: [7210, 7211, 7216, 7217, 7342, 7349] },
  { key: 'personalServices', codes: [7251, 7278, 7299] },
  { key: 'funeral', codes: [7261] },
  { key: 'dating', codes: [7273] },
  { key: 'counseling', codes: [7277] },
  {
    key: 'businessServices',
    codes: [7311, 7321, 7322, 7339, 7361, 7392, 7393, 7394, 7399, 8734, 8999],
  },
  { key: 'itServices', codes: [7372, 7375, 7379] },
  { key: 'autoService', codes: [7531, 7534, 7535, 7538, 7542, 7549] },
  { key: 'repairs', codes: [7622, 7623, 7629, 7631, 7641, 7692, 7699] },
  { key: 'gambling', codes: [7800, 7801, 7802, 7995, 9406] },
  { key: 'cinema', codes: [7829, 7832, 7841] },
  { key: 'liveEntertainment', codes: [7911, 7922, 7929] },
  { key: 'recreation', codes: [7932, 7933, 7941, 7992, 7997, 7999] },
  { key: 'attractions', codes: [7991, 7996, 7998] },
  { key: 'healthcare', codes: [8011, 8031, 8041, 8049, 8099] },
  { key: 'dental', codes: [8021] },
  { key: 'vision', codes: [8042, 8043] },
  { key: 'hospitalsCare', codes: [8050, 8062] },
  { key: 'medicalLabs', codes: [8071] },
  { key: 'legal', codes: [8111] },
  { key: 'education', codes: [8211, 8220, 8241, 8244, 8249, 8299] },
  { key: 'childcare', codes: [8351] },
  { key: 'charity', codes: [8398] },
  { key: 'associations', codes: [8641, 8675, 8699] },
  { key: 'political', codes: [8651] },
  { key: 'architectureEngineering', codes: [8911] },
  { key: 'accounting', codes: [7276, 8931] },
  { key: 'government', codes: [9211, 9222, 9223, 9399, 9405] },
  { key: 'taxes', codes: [9311] },
  { key: 'postal', codes: [9402] },
  { key: 'emergency', codes: [9702] },
  { key: 'intraCompany', codes: [9950] },
];

function isCodeInRule(code, rule) {
  return rule.codes?.includes(code)
    || rule.ranges?.some(([from, to]) => code >= from && code <= to);
}

export function getMccCategoryKey(mcc) {
  const raw = String(mcc ?? '').trim();

  if (!/^\d{1,4}$/.test(raw)) {
    return 'general';
  }

  const code = Number.parseInt(raw, 10);
  const rule = MCC_CATEGORY_RULES.find((candidate) => isCodeInRule(code, candidate));

  return rule?.key || 'general';
}

export { MCC_CATEGORY_RULES };
